import React, { useCallback, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import OpenInFullSharpIcon from "@mui/icons-material/OpenInFullSharp";
import CloseFullscreenSharpIcon from "@mui/icons-material/CloseFullscreenSharp";
import { FormControlLabel } from "@mui/material";
import { Typography } from "@mui/material";

function CheckboxContainer({
  checkAllCategories,
  setCheckAllCategories,
  nodes,
  categoryVisibility,
  setCategoryVisibility,
  isExpanded,
  setIsExpanded,
}) {
  const handleCategoryCheckbox = useCallback(
    (categoryId) => {
      // Update the state of the individual category checkbox
      setCategoryVisibility((prevVisibility) => {
        const updatedVisibility = { ...prevVisibility };
        updatedVisibility[categoryId] = !prevVisibility[categoryId];

        // Check if all category checkboxes are now unchecked
        const allUnchecked = Object.keys(updatedVisibility).every(
          (value) => !value
        );

        // Update the state of the "SELECT ALL" checkbox
        setCheckAllCategories(allUnchecked);

        // Ensure that categoryVisibility is updated before proceeding
        localStorage.setItem(
          "categoriesVisibility",
          JSON.stringify(updatedVisibility)
        );
        return updatedVisibility;
      });
    },
    [setCategoryVisibility, setCheckAllCategories]
  );

  const handleSelectAllCategoryCheckboxes = () => {
    // Update the checked state of all category checkboxes
    const updatedChecklist = {};

    // Get all node ids for category nodes
    for (const node of nodes) {
      if (node.type === "default") {
        updatedChecklist[node.id] = !checkAllCategories;
      }
    }

    // Set the updated checklist for all category checkboxes
    setCategoryVisibility(updatedChecklist);

    //Synchronised with localstorage in updating the categories
    localStorage.setItem(
      "categoriesVisibility",
      JSON.stringify(updatedChecklist)
    );

    // Toggle the "Select All" checkbox
    setCheckAllCategories(!checkAllCategories);
  };

  //Check if the browser if Firefox to apply specific styles to scrollbar
  useEffect(() => {
    if (navigator.userAgent.includes("Firefox")) {
      document.body.classList.add("firefox");
    }
    return () => {
      document.body.classList.remove("firefox");
    };
  }, []);

  return (
    <div
      className={`checkbox-container flex-child ${
        isExpanded ? "expanded" : ""
      }`}
    >
      <label className="category-title">Categories</label>
      <div
        className="categoriesCheckboxes"
      >
        {/* SELECT ALL checkbox */}
        <div className="check-box-item">
          <div className="check-box-icon-wrapper">
            <input
              type="checkbox"
              checked={checkAllCategories}
              onChange={handleSelectAllCategoryCheckboxes}
            />
          </div>
          <label className="checkbox-categories-label">Select All</label>
        </div>
      </div>
      {/* Display the first five category checkboxes by default */}
      {nodes
        .filter((node) => node.type === "default")
        .slice(0, isExpanded ? undefined : 5)
        .map((node) => (
          <div
            key={node.id}
            className="categoriesCheckboxes"
            style={{ display: "flex", marginLeft: "10px" }}
          >
            {/* Category checkboxes */}
            <div className="check-box-item">
          <div className="check-box-icon-wrapper">
            <input
              type="checkbox"
              // If checkAllCategories is true then all category checkboxes must be checked
                  // Otherwise check individual category checkboxes
              checked={checkAllCategories
                ? categoryVisibility[node.id]
                : !!categoryVisibility[node.id]}
              onChange={() => handleCategoryCheckbox(node.id)}
            />
          </div>
          <label className="checkbox-categories-label">{node.data.label}</label>
        </div>
          </div>
        ))}
      {/* Display open icon to expand checkbox container and display the rest of category checkboxes available  */}
      {/* Otherwise display close icon and collapse checkbox container */}

      {nodes.filter((node) => node.type === "default").length > 5 ? (
        isExpanded ? (
          <CloseFullscreenSharpIcon
            className="icon-minimize"
            onClick={() => setIsExpanded(!isExpanded)}
          />
        ) : (
          <OpenInFullSharpIcon
            className="icon-maximize"
            onClick={() => setIsExpanded(!isExpanded)}
          />
        )
      ) : (
        ""
      )}
    </div>
  );
}

export default CheckboxContainer;
